import { baseClient } from './baseRequest';

export type ShopifyProductPageUrls = {
  previewUrl: string;
  productUrl?: string;
};

export type PreviewGeneratorApiClient = {
  getCollectionShopifyPreviewUrl: (
    collectionId: string,
  ) => Promise<ShopifyProductPageUrls>;
};

const shopifyProductPageApiClient: PreviewGeneratorApiClient = {
  getCollectionShopifyPreviewUrl: async (collectionId: string) => {
    return baseClient.get<ShopifyProductPageUrls>({
      url: `/shopify-product-page/collection/${collectionId}`,
    });
  },
};

export default shopifyProductPageApiClient;
